export default function Sparkline({
  points,
  mode = 'line',
  color = 'currentColor',
  height = 16,
}: {
  points: { date: string; index: number }[]
  mode?: 'line' | 'bar'
  color?: string
  height?: number
}) {
  if (!points.length) return <svg width="100%" height={height} aria-hidden="true" />
  const w = 80
  const h = height
  const max = Math.max(1, ...points.map((p) => p.index))
  const min = Math.min(0, ...points.map((p) => p.index))
  const span = max - min || 1
  const x = (i: number) => (points.length === 1 ? w / 2 : (i / (points.length - 1)) * w)
  const y = (v: number) => h - ((v - min) / span) * h
  return (
    <svg width="100%" height={h} viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" aria-hidden="true">
      {mode === 'line' ? (
        <polyline
          fill="none"
          stroke={color}
          strokeWidth={1.5}
          points={points.map((p, i) => `${x(i).toFixed(1)},${y(p.index).toFixed(1)}`).join(' ')}
        />
      ) : (
        points.map((p, i) => {
          const bw = w / points.length - 1
          const bh = Math.max(0.5, ((p.index - min) / span) * h)
          return (
            <rect
              key={i}
              x={(i * (w / points.length)).toFixed(1)}
              y={(h - bh).toFixed(1)}
              width={bw.toFixed(1)}
              height={bh.toFixed(1)}
              fill={color}
            />
          )
        })
      )}
    </svg>
  )
}
